import { useState } from "react";
import { type Dish } from "../../../mocks/home";
import { waLink, WHATSAPP_INTENTS } from "../config";

interface MenuSummaryProps {
  selectedDishes: Dish[];
  onClear: () => void;
}

export default function MenuSummary({ selectedDishes, onClear }: MenuSummaryProps) {
  const [completed, setCompleted] = useState(false);

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-6 sticky top-24">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-xl font-bold text-foreground-950">MENÜN</h3>
        {selectedDishes.length > 0 && (
          <button
            onClick={onClear}
            className="text-xs font-semibold text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            Temizle
          </button>
        )}
      </div>

      {selectedDishes.length === 0 ? (
        <div className="mt-6 py-8 text-center border border-dashed border-background-300 rounded-lg">
          <div className="w-12 h-12 rounded-full bg-background-100 text-foreground-400 flex items-center justify-center mx-auto">
            <i className="ri-restaurant-line text-xl"></i>
          </div>
          <p className="mt-3 text-sm text-foreground-500">
            Henüz seçim yapmadın.
            <br />
            Canın ne çekerse ekle.
          </p>
        </div>
      ) : (
        <ul className="mt-5 space-y-2 max-h-64 overflow-y-auto pr-1">
          {selectedDishes.map((dish) => (
            <li
              key={dish.id}
              className="flex items-center gap-3 py-2 border-b border-background-100 last:border-0"
            >
              <img
                src={dish.image}
                alt={dish.name}
                className="w-11 h-11 rounded-md object-cover object-top shrink-0"
              />
              <div className="flex-1 min-w-0">
                <span className="block text-sm font-semibold text-foreground-900 truncate">
                  {dish.name}
                </span>
                <span className="block text-xs text-foreground-500">
                  {dish.calories} kcal
                </span>
              </div>
              <i className="ri-check-line text-primary-500"></i>
            </li>
          ))}
        </ul>
      )}

      <div className="mt-5 flex items-end justify-between">
        <div>
          <span className="block text-xs font-semibold text-foreground-500 uppercase tracking-wider">
            Günlük Öğün
          </span>
          <span className="font-heading text-3xl font-bold text-foreground-950">330 ₺</span>
        </div>
        <span className="text-xs text-foreground-500">Sabit fiyat</span>
      </div>

      {!completed ? (
        <button
          onClick={() => setCompleted(true)}
          className="mt-5 w-full py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          MENÜMÜ TAMAMLA
        </button>
      ) : (
        <div className="mt-5 space-y-3 animate-fade-in">
          <h4 className="font-heading text-2xl font-bold text-foreground-950">
            GÜZEL SEÇİM.
          </h4>
          <p className="text-sm text-foreground-600 leading-relaxed">
            Menünü kaydetmek ve teslimat bilgilerini belirlemek için devam et.
          </p>
          <a
            href="#giris"
            className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-smartphone-line"></i>
            TELEFON NUMARAMLA DEVAM ET
          </a>
          <a
            href={waLink(WHATSAPP_INTENTS.menuSummary)}
            target="_blank"
            rel="nofollow noopener"
            className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-md border-2 border-accent-500 text-accent-900 text-base font-bold hover:bg-accent-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WHATSAPP'TAN DEVAM ET
          </a>
        </div>
      )}
    </div>
  );
}